import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiScoreSuggestionType,
  BackendMutationScoreCopyTextArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ScoreCopyText(
    $projectId: ID!
    $assetType: String!
    $text: String!
    $html: String
    $scoringMethod: ScoringMethodInput
  ) {
    scoreCopyText(
      projectId: $projectId
      assetType: $assetType
      text: $text
      html: $html
      scoringMethod: $scoringMethod
    ) {
      score
      performancePredictionsScoreLocked
      ageScoreHistogram
      genderScoreHistogram
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        name
        type
      }
      secondaryScoringMethod {
        id
        name
        type
      }
    }
  }
`;

type Variables = BackendMutationScoreCopyTextArgs;
type Result = BackendMultiScoreSuggestionType;

export const scoreCopyText = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
